export const LARGE_ENOUGH_GAP = 1000000;

// excluding animated so it doesn't get into the SVG path.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function SVGSegment({ baseOffset, path, size, offset, width, color, ...props }) {
  const style = {
    strokeDashoffset: baseOffset + offset,
    strokeDasharray: `${size} ${LARGE_ENOUGH_GAP}`,
    strokeWidth: `${width}px`,
    stroke: color,
  };
  return <path d={path} style={style} {...props} />;
}
